import { render, staticRenderFns } from "./LanguageSelectBox.vue?vue&type=template&id=7850d9f9&scoped=true&lang=pug&"
import script from "./LanguageSelectBox.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectBox.vue?vue&type=style&index=0&id=7850d9f9&scoped=true&lang=css&"
import style1 from "./LanguageSelectBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7850d9f9",
  null
  
)

export default component.exports